import "./App.css";
import Portfolio from "./components/portfolio";
import "./components/portfolio.css";
import React from "react";

function App() {
  return (
    <div className="App" class="xl:px-10 sm:px-5">
      <Portfolio />
    </div>
  );
}

export default App;
